import { createFileRoute } from '@tanstack/react-router';

import { NIS2AssetRegister } from '@/features/nis2/components/NIS2AssetRegister';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2/asset-register')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2AssetRegister', { defaultValue: 'NIS2 Asset Register' }),
  }),
  component: NIS2AssetRegister,
});
